import useDefinedContext from "hooks/useDefinedContext";
import { FeatureFlagStatusContext } from "../FeatureFlagProvider";

function useFeatureFlagStatus() {
  return useDefinedContext(FeatureFlagStatusContext);
}

export default useFeatureFlagStatus;
